<template lang="html">

		<div>
		<div class="acceso" :style="'background:url('+background+') center/cover no-repeat'"></div>
	</div>
</template>

<script lang="js">

	import {mapActions,mapGetters} from 'vuex';


	export default  {
		name: 'error-404',
		created(){
			const urlParams = window.location.search;
			const respuesta = urlParams.split("respuesta=")[1];
			this.loginSAML(respuesta);
		},
		computed:{
			...mapGetters({
				background :'getBackground'
			})
		},
		methods :{
			...mapActions(['loginSAML'])
		},

	}
</script>

<style scoped lang="scss">
	.acceso {
		width: 100%;
		height: 100vh;
		display: inline-block;
		
	}
</style>



// WEBPACK FOOTER //
// src/components/views/acceso-saml.vue